// noinspection JSUnusedGlobalSymbols
export enum NimbusPermissionSet {
  NimbusAdmin = 'nimbus_admin',
  NimbusUser = 'nimbus_user',

  Owner = 'owner',
  OwnerLimited = 'owner_limited',
  TeamMember = 'member',
  ServiceOwner = 'nimbus_service_owner',
  ServiceAgent = 'nimbus_service_agent',
  Anonymous = 'anonymous',
  AuthorizedUser = 'authorized_user',
  TenantUser = 'tenant_user',
  PartnerAdmin = 'partner_admin',
  PartnerAdminForAllTenants = 'partner_admin_for_all_tenants',
  PartnerAdminForTenant = 'partner_admin_for_tenant',
  TenantAdmin = 'tenant_admin',
  ChildOuAdmin = 'child_ou_admin',
  ParentOuAdmin = 'parent_ou_admin',
  OuAdmin = 'ou_admin',
  ServiceSupervisor = 'service_supervisor',
  ParentServiceSupervisor = 'parent_service_supervisor',
  ChildServiceSupervisor = 'child_service_supervisor',
  UserSupervisor = 'user_supervisor',
  WorkflowAdminLimited = 'workflow_admin_limited',
  ParentWorkflowAdminLimited = 'parent_workflow_limited_admin',
  ChildWorkflowAdminLimited = 'child_workflow_limited_admin',
}
